module.exports = {
	"trackingId": "DUMMY TRACKING ID"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/googleAnalytics-example.credentials.json
// module id = 1408
// module chunks = 0